<template>
    <div class="order-total display-flex justify-content-end align-items-center">
        <table>
            <tbody>
            <tr>
                <td><span>Итого:</span></td>
                <td><span>{{orderTotal['ORDER_TOTAL_PRICE']}}&nbsp;<i class="fa fa-rub"></i></span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
  export default {
    name: 'order-total',
    props: {
      orderTotal: {
        type: [Object, Array],
        default () {
          return {}
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/order/components/OrderTotal.vue